<template>
  <div class="content">

      <s-location buy title="변호사 출입 조회 기록"/>

      <!-- <h4 class="sub_title02 ">변호사 출입 조회 기록</h4> -->
      <div class="btn_group mt0">
        <div class="right">
          <button @click="initData" class="btn icon reload">초기화</button>
          <button @click="doSearch" class="btn icon search_black">검색</button>
          <!-- <button @click.prevent="$refs.excel.down()" class="btn icon excel">엑셀 다운</button> -->
        </div>
      </div>
      <table class="tbl01 sch_tbl">
        <tr>
          <th>날짜</th>
          <td colspan="3">
            <i-input-date input-class="w_inputno" title="시작일" v-model="search.s_dtfr" :placeholder="search.s_dtfr"/>
          ~ <i-input-date input-class="w_inputno" title="종료일" v-model="search.s_dtto" :placeholder="search.s_dtto"/>
          <br class="mobile"/>
            <s-date-range :fr.sync="search.s_dtfr" :to.sync="search.s_dtto" />
          </td>
        </tr>
        <tr>
          <th>변호사명</th>
          <td><input type="text" class="sch_input" v-tooltip="'조회할 변호사명'" v-model="search.s_membnm" placeholder="변호사명" @keyup.enter="doSearch()"/></td>
          <th>등록번호</th>
          <td><input type="text" class="sch_input" v-tooltip="'조회할 등록번호'" v-model="search.s_membno" placeholder="등록번호" @keyup.enter="doSearch()"/></td>
        </tr>
        <tr>
          <th>결과구분</th>
          <td><i-input-sel v-model="search.s_result" itemsp="all / 전체 | 조회성공 | 유효하지 않음 | 데이터 없음" @input="doSearch" /></td>
          <th>QRCODE</th>
          <td><input type="text" class="sch_input" v-tooltip="'조회할 등록번호'" v-model="search.s_qrcode" placeholder="QRCODE" @keyup.enter="doSearch()"/></td>
        </tr>
      </table>

      <s-loading v-if="list.loading"/>
      <!-- 테이블 -->
      <div class="scroll_wrap"> <!--모바일 스크롤 -->
        <p class="scroll_txt "> &lt;-&gt; 좌우 스크롤을 이용하세요</p>

        <table class="tbl01 lawlist">
          <thead>
            <tr>
              <th class="no" style="width: 70px;">순번</th>
              <th class="day" style="width: 70px;">조회시간</th>
              <th width="">QRCODE</th>
              <th width="200px">조회결과</th>
              <th width="100px">변호사명</th>
              <th width="100px">등록번호</th>
            </tr>
          </thead>
            <tr v-for="(item,i) in list.items" :key=i>
              <td>{{ list.totalCount - ((list.pageNo -1) * list.listSize) - i }}</td>
              <td>
                {{ item.logdt }}
                <!-- {{ item.logdt | moment('YYYY.MM.DD.') }} -->
              </td>
              <td>{{ item.qrcode }}</td>
              <td>{{ item.result }}</td>
              <td>{{ item.membnm }}</td>
              <td>{{ item.membno }}</td>
            </tr>
        </table>
      </div><!--//scroll_wrap -->
      <!-- //테이블 -->
      <div class="paging">
        <p class="num">
            <s-page :pageNo.sync="list.pageNo" :totalCount="list.totalCount" :listSize="list.listSize" @changePage="doSearch"/>
        </p>
      </div>


    </div> <!-- content : width=950px; -->
</template>

<script>
let ui

export default {
  data() {
    return {
      search : {},
      search_init : {
        s_dtfr : this.$moment().subtract(1, 'months').format("YYYY-MM-DD")
      , s_dtto : this.$moment().format("YYYY-MM-DD")
      },
      sitem : {},
      code: {},
      chkAll : false,
      list: {
        loading: false,
        items: [],
        totalCount: 0,
        listSize : 10,
        pageNo : 1,
      },
    }
  },
  watch : {
    '$route': 'initData',
  },
  created() {
    ui = this.$ui;
    this.search = { ...this.search_init }
  },
  mounted() {
     // 공통코드 로드
    // ui.codeLoad("PAYSTAT", code => {
    //   this.code = code
    //   // 입금상태 검색조건 : 기존자료 제외
    //   this.code.PAYSTAT = this.code.PAYSTAT.filter(e => e.value != 'MI')
    //   this.doSearch()
    //   this.doInSearch()
    //   this.$refs.rfmain.load()
    // });
    this.doSearch()
  },
  methods: {
    chk_cnt()     { return this.inlist.totalCount < 1 ? 0 : this.inlist.items.reduce((t,p)=>t+=p.chk ? 1 : 0,0) }, // 총 미처리 입금 건수
    chk_amt()     { return this.inlist.totalCount < 1 ? 0 : this.inlist.items.reduce((t,p)=>t+=p.chk ? p.amt : 0,0) }, // 선택한 미처리 입금 금액 합계
    chk_amt_tot() { return this.inlist.totalCount < 1 ? 0 : this.inlist.items.reduce((t,p)=>t+=p.amt,0) },  // 총 미처리 입금 금액 합계
    initData(){ // 현재 메뉴 다시 클릭 시
      this.search = T.deepCopy(this.search_init)
      // this.doSearch()
      // this.doInSearch()
      // this.$refs.rfmain.load()
    },
    doSearch() {
      //this.search.iv_incmgdtfr = reaplace(this.)
      this.$ui.httpGetList(this.list
        , '/mypage/hist_qrcode'
        , {
          ...this.search
          , listSize      : this.list.listSize
          , pageNo      : this.list.pageNo
        },
        ret => {

          const {status, msg} = ret.data;
          if (status == 'need_pw') {
            ui.alert_error(msg, "오류")
              .then(()=>this.$router.push('/member/pw_confirm'))
            return
          }

          this.list.totalCount = _.get(ret, "data.tot_rows", 0)
          this.list.items      = _.get(ret, "data.list", [])
        })
    },

  },
}
</script>
<style scoped>
  .tbl01 th { max-width:8%;}
  .tbl01 th.gubun { width:300px;}
  .tbl01 tr.gubun_d th { width:40px; padding: 0; margin: 0}

  #id_msg:hover .toggleInfo {  margin-top:50px; margin-left:-30px; display: inline-block;  width:750px;}
  .toggleInfo .tit_info {  color:#fff; display: inline-block; padding: 10px 15px 10px 40px; ;width:100%; box-sizing: border-box; font-size: 15px;;background:#333 url('/images/common/icon_info_org.png')  15px 50% no-repeat;  ;}


</style>